<script>
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    Datatable,
    Pagination,
  },
  props: {
    // "kkj" | "pembinaan_grade"
    tipeAsesmen: {
      type: String,
      required: true,
    },
  },
  data() {
    let sortOrders = []; // select sortOrder
    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "Kode Tes", name: "kode_tes" },
      { width: "auto", label: "Pelaksanaan", name: "-" },
      { width: "auto", label: "Keterangan", name: "keterangan" },
      { width: "150px", label: "Tanggal Mulai", name: "tanggal_mulai" },
      { width: "150px", label: "Tanggal Selesai", name: "tanggal_selesai" },
      { width: "150px", label: "Aksi", name: "-" },
    ];
    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      sessionUserId: localStorage.session_user_id,

      tableData: {
        columns: columns,
        sortKey: "kode_tes",
        sortOrders: sortOrders,
        loading: true,
        data: [],
        filter: {
          page: 1,
          per_page: 10,
          // 3 = Selesai
          status_pengerjaan: [3],
          tipe_asesmen: this.tipeAsesmen,
        },
        pagination: {
          lastPage: "",
          currentPage: "",
          total: "",
          lastPageUrl: "",
          nextPageUrl: "",
          prevPageUrl: "",
          from: "",
          to: "",
          links: "",
        },
      },
    };
  },
  async mounted() {
    await this.getDataTable();
  },
  methods: {
    getDataTable(resetPage = true) {
      let self = this;
      self.tableData.loading = true;
      if (resetPage) {
        self.tableData.filter.page = 1;
      }

      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "pegawai/jadwal-asesmen",
        params: {
          id_pegawai: this.sessionUserId,
          ...self.tableData.filter,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            let response_data_fix = response_data.data;
            self.tableData.data = response_data_fix.data;
            self.configPagination(response_data_fix);
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
          self.tableData.loading = false;
        })
        .catch((errors) => {
          console.log(errors);
          self.tableData.loading = false;
        });
    },
    configPagination(data) {
      this.tableData.pagination.lastPage = data.last_page;
      this.tableData.pagination.currentPage = data.current_page;
      this.tableData.pagination.total = data.total;
      this.tableData.pagination.lastPageUrl = data.last_page_url;
      this.tableData.pagination.nextPageUrl = data.next_page_url;
      this.tableData.pagination.prevPageUrl = data.prev_page_url;
      this.tableData.pagination.from = data.from;
      this.tableData.pagination.to = data.to;
      this.tableData.pagination.links = data.links;
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableData.filter.page = link.get("page");
      this.getDataTable(false);
    },
    sortBy(key) {
      let self = this;
      self.tableData.sortKey = key;
      self.tableData.sortOrders[key] = self.tableData.sortOrders[key] * -1;
      self.getDataTable();
    },
    detail(row_data) {
      this.$router.push({
        name: "history-asesmen-detail",
        params: { id: row_data.idjadwal },
        query: {
          kode_tes: row_data.kode_tes,
          keterangan: row_data.keterangan,
          tanggal_mulai: row_data.tanggal_mulai,
          tanggal_selesai: row_data.tanggal_selesai,
          token_jadwal: row_data.token_jadwal,
        },
      });
    },
  },
};
</script>
<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <datatable
          :columns="tableData.columns"
          :sortKey="tableData.sortKey"
          :sortOrders="tableData.sortOrders"
          @sort="sortBy"
        >
          <tbody>
            <tr v-if="tableData.loading">
              <td colspan="99" class="text-center">
                <i class="fas fa-spinner fa-spin"></i> Loading...
              </td>
            </tr>
            <tr
              v-else-if="!tableData.data || tableData.data.length === 0"
              class="text-center"
            >
              <td class="text-center" colspan="99">Data Tidak Tersedia</td>
            </tr>
            <tr
              v-else
              v-for="(row_data, key_data) in tableData.data"
              :key="row_data.idjadwal"
            >
              <td class="text-center">
                {{ (tableData.pagination.from || 1) + key_data }}
              </td>
              <td class="text-center">{{ row_data?.kode_tes || "-" }}</td>
              <td class="text-center">{{ row_data?.pelaksanaan || "-" }}</td>
              <td class="text-center">{{ row_data?.keterangan || "-" }}</td>
              <td class="text-center">{{ row_data?.tanggal_mulai || "-" }}</td>
              <td class="text-center">{{ row_data?.tanggal_selesai || "-" }}</td>
              <td class="text-center">
                <button
                  type="button"
                  class="btn btn-info btn-sm"
                  @click="detail(row_data)"
                >
                  <i class="fa fa-external-link-alt"></i> Detail
                </button>
              </td>
            </tr>
          </tbody>
        </datatable>
      </div>
      <pagination
        :pagination="tableData.pagination"
        @to-page="toPage"
      ></pagination>
    </div>
  </div>
</template>